import { Injectable } from '@angular/core';
import { SignTitleAdjustment } from '../../../../model/sign/title/sign-title-adjustment';

@Injectable({
  providedIn: 'root'
})
export class SignTitleAdjustmentFactory {
  public createSignTitleAdjustment(): SignTitleAdjustment {
    const toReturn = new SignTitleAdjustment();
    toReturn.examples = [];

    return toReturn;
  }
}
